import { Component, DestroyRef, ElementRef, inject, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from '../../elements/pagination/pagination.component';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { MatSortModule, Sort } from '@angular/material/sort';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { HttpServiceService } from '../../services/http-service.service';
import { LoadingService } from '../../services/loading.service';
import { Offcanvas } from 'bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { Select2, Select2Data } from 'ng-select2-component';
import { debounceTime, distinctUntilChanged, filter, Subject, Subscription, switchMap, tap } from 'rxjs';
import { APP_CONSTANTS, USER_PERMISSIONS } from '../../app.constants';
import { LocalStorageService } from '../../services/local-storage.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UserInfo } from '../../models/users.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-inspection',
  imports: [ReactiveFormsModule, PaginationComponent, BreadcrumbComponent, MatSortModule, NgIf, NgSelectModule, NgFor, RouterModule, Select2, DatePipe],
  templateUrl: './inspection.component.html',
  styleUrl: './inspection.component.css'
})
export class InspectionComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Inspections',
    breadcrumb_url: '/admin'
  }
  addInspectionForm!: FormGroup;
  updateStatusForm!: FormGroup;
  active = 1;
  page: any = 1;
  totalRows: number = 20;
  totalPage: any = 0;
  allData: any = [];
  properties: Select2Data = [];
  private httpService = inject(HttpServiceService);
  propertiesList: any = [];
  hasMore: boolean = true;
  lastSearchTerm: any;
  offset_limit: number = 20;
  searchInput$ = new Subject<string>();
  loadingService = inject(LoadingService);
  allUsers = [
    {
      property_name: "Inspection",
      inspection_name: "A/C",
      inspection_type: 'Move In Inspection',
      schedule_start_date: '5',
      schedule_end_date: "14/01/2015",
      files: "",
      status: "Submitted",
    }
  ];

  orderData: any;
  ticketadd_edit: boolean = false;
  @ViewChild('addTicketButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  defaultDays  = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 30, 60, 90, 120, 180];
  defaultSelectData : Select2Data = [];
  private modalService = inject(NgbModal);
  private authService = inject(LocalStorageService);
  selectedFiles: any = [];
  private createInspectionSubscription?: Subscription;
  private getAllInspectionsSubscription?: Subscription;
  private lastSearchTermSubscription?: Subscription;
  private getInspectionDetailsById? : Subscription;
  private deleteInspectionImageSubscription?: Subscription;
  private deleteInspectionSubscription? : Subscription;
  private getAllUsersSubscription?: Subscription;
  searchForm!: FormGroup;
  disableClear: boolean = false;
  users: Select2Data = [];
  isEditInspection: boolean = false;
  uploadedImages: any = [];
  pageCount : number = 1;
  isInspectionView :boolean = false;
  private userInfo : UserInfo;
  queryParamsSubsscription?: Subscription;
  isQueryParamsExists : boolean = false;
  sortBy : string = '';
  orderBy : string = '';
  private distroyRef = inject(DestroyRef);

  constructor(private fb: FormBuilder, private alertService: NgxToastrService, private route: ActivatedRoute, private router : Router) {
    this.addInspectionForm = this.fb.group({
      property_id: [null, [Validators.required]],
      inspection_name: ['', [Validators.required]],
      inspection_type: [null, [Validators.required]],
      schedule_start_date: [''],
      schedule_end_date: [''],
      inspection_notes : [''],
      files: [null],
      id : [''],
      inspection_status : [null]
    });
    this.updateStatusForm = this.fb.group({
      update_status: ['', [Validators.required]]
    });
    this.searchForm = this.fb.group({
      name: [''],
      property_id: [null],
      inspection_type: [null],
      inspection_status: [null],
      managed_by: ['']
    })

    this.orderData = this.allUsers.slice();
    this.userInfo = this.authService.getItem("userInfo") as UserInfo;
  }

  ngOnInit(): void {
    for(let sub of this.defaultDays){
       this.defaultSelectData.push(
        {
          value: sub,
          label: sub?.toString(),
          data: { name: sub }
        }
       )
    }
    this.getAllProperties();
    if(this.checkManagedByFilter) this.getAllUsers();
    this.lastSearchTermSubscription = this.searchInput$
      .pipe(
        debounceTime(300),
        filter(term => {
          const skip = term === this.lastSearchTerm;
          return !skip;
        }),
        tap((term) => {
          this.page = 1;
          this.hasMore = true;
          this.lastSearchTerm = term;
        }),
        switchMap(term => {
          let query = term ? "&name=" + term : '';
          return this.httpService.getAllProperties(1, 20, query);
        }
        )
      )
      .subscribe(results => {
        this.properties = [];
        this.propertiesList = results.data["properties"] ?? [];
        if (this.propertiesList.length >= results.data["total"]) {
          this.hasMore = false;
        }
        for (let resp of this.propertiesList) {
          this.properties.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      });
    // this.getAllInspections();
    this.searchForm.get('name')?.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntilDestroyed(this.distroyRef)
      )
      .subscribe(value => {
        if(!this.isQueryParamsExists) this.handleSearch(value);
        this.isQueryParamsExists = false;
      });
      this.queryParamsSubsscription = this.route.queryParams.subscribe((data: any) => {
      let resp = { ...data };
      if(resp.page){
         this.page = parseInt(resp.page);
         delete resp.page;
         const hasAnyValue = Object.values(resp).some(value => !!value);
         if(hasAnyValue){
          this.isQueryParamsExists = true;
          this.searchForm.patchValue(resp);
         }
        this.handleSearch('', "keepPage", resp);
      }else{
        this.resetSearchForm();
      }
    });
  }

  onSearch(): void {
    console.log(this.searchForm.value);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const offcanvasElement = this.offcanvas?.nativeElement;
      if (offcanvasElement) {
        this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    });
  }

  getAllProperties(query: any = '') {
    this.httpService.getAllProperties(this.page, this.offset_limit).subscribe({
      next: (response) => {
        this.propertiesList = response.data["properties"] ?? [];
        if (this.propertiesList.length >= response.data["total"]) {
          this.hasMore = false;
        }
        this.properties = [];
        for (let resp of this.propertiesList) {
          this.properties.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      }
    })
  }

  onScrollToEnd() {
    // Optional: For pagination / infinite scroll
    if (!this.hasMore) return;
    this.page += 1;
    this.offset_limit += 10;
    this.httpService.getAllProperties(this.page, this.offset_limit).subscribe(response => {
      let resp = response.data["properties"] ?? [];
      if (this.propertiesList.length >= response.data["total"]) {
        this.hasMore = false;
      }
      this.propertiesList = [...this.propertiesList, ...resp];
      this.properties = [];
      for (let resp of this.propertiesList) {
        this.properties.push(
          {
            value: resp.uid,
            label: resp.name,
            data: { name: resp.name }
          }
        )
      }
    });
  }

  uploadImages(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      this.selectedFiles = Array.from(inputElement.files);
    }
  }

  viewImage(url : string){
    window.open(url , "_blank");
  }

  deleteImage(id : string){
    this.deleteInspectionImageSubscription = this.httpService.deleteInspectionUploads(id).subscribe({
      next : (response) => {
        this.uploadedImages  = this.uploadedImages.filter((img: { id: string; }) => img.id !=id);
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  editInspection(id: string, isView : boolean = false) {
    this.isInspectionView = isView;
    this.isEditInspection = isView ? false : true;
    this.getInspectionDetailsById  = this.httpService.getInspectionDetailsById(id).subscribe({
      next : (response) => {
        this.uploadedImages  = response.data["uploads"];
        this.addInspectionForm.patchValue({
          ...response.data,
          property_id : response.data["property_name"]
        });
        this.addInspectionForm.get('property_id')?.disable();
        if(this.isInspectionView) this.addInspectionForm.disable();
        this.ticketPopupOpen();
      }
    })
  }

  addTicketEvent(data: any) {
    this.ticketPopupOpen();
  }

  ticketPopupOpen() {
    this.ticketadd_edit = !this.ticketadd_edit;
    if(!this.isEditInspection && !this.isInspectionView) this.uploadedImages = [];
    if (this.offcanvasInstance) {
      this.offcanvasInstance.show();
    }
  }

  tikcetClose() {
    this.isEditInspection = false;
    this.addInspectionForm.enable();
    this.ticketPopupOpen();
    this.addInspectionForm.reset();
    if (this.offcanvasInstance) {
      this.offcanvasInstance.hide();
    }
  }

  onSubmit() {
    const formData = new FormData();
    this.selectedFiles.forEach((file: string | Blob, index: any) => {
      formData.append('files', file);
    });
    let uid : string = '';
    Object.keys(this.addInspectionForm.controls).forEach((key) => {
      let value = this.addInspectionForm.get(key)?.value;
      if(key=='property_id'){
        if(typeof(value) == 'string'){
          let selectedProperty = this.propertiesList.find((list: { name: any; }) => list.name == value);
          value = selectedProperty ? selectedProperty["uid"] : ""
        }else{
          value = value?.value ?? "";
        }
      }
      if(key == 'id') uid = value;
      if(value && key != 'id') formData.append(key, value);
    });
    if(this.isEditInspection){
      this.createInspectionSubscription = this.httpService.updateInspection(uid, formData).subscribe({
        next: (response) => {
          this.getAllInspections();
          this.addInspectionForm.reset();
          this.tikcetClose();
          this.selectedFiles = [];
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }else{
      this.createInspectionSubscription = this.httpService.createInspection(formData).subscribe({
        next: (response) => {
          this.page = 1;
          this.getAllInspections();
          this.addInspectionForm.reset();
          this.tikcetClose();
          this.selectedFiles = [];
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }
  }

  viewInspection(id: string){
    let data = {
      ...this.searchForm.value,
      page : this.page
    };
    this.router.navigate(['/admin/create-inspection',id],{
      queryParams: data
    });
  }

  inspectionReport(id : string, property_id : string){
    let data = {
      ...this.searchForm.value,
      page : this.page
    };
    this.router.navigate(['/admin/view-inspection',id, property_id], {
      queryParams: data
    });
  }

  resetSearchForm() {
    this.page = 1;
    this.sortBy = '';
    this.orderBy = '';
    this.searchForm.reset({
      inspection_status: null
    }, { emitEvent: false });
    this.getAllInspections();
    this.disableClear = false;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
    this.isQueryParamsExists = false;
  }

  handleSearch(value: any, keepPage: string = '', data : any = '') {
    const searchData = data ? data : this.searchForm.value;
    let query = '';
    for (let key in searchData) {
      if (searchData[key]) {
        let search_val = searchData[key];
        if(key == 'property_id'){
          search_val = search_val.value ?? "";
        }
        query += `&${key}=${search_val}`;
      }
    }
    if(this.sortBy) query += `&sortBy=${this.sortBy}&orderBy=${this.orderBy}`;
    if (!keepPage) this.page = 1;
    if (query || !value) this.getAllInspections(query);
    this.disableClear = (value || query) ? true : false;
  }

  getAllInspections(query: any = '') {
    this.getAllInspectionsSubscription = this.httpService.getAllInspections(this.page, this.offset_limit, query).subscribe({
      next: (response) => {
         this.allUsers = response.data['inspections'] ?? [];
         this.orderData = this.allUsers.slice();
         this.allData = this.paginator(this.orderData, this.page, this.totalRows, response["data"]?.total);
         this.totalPage = response.data.total;
         this.pageCount = response.data.pageCount;
      }
    });
  }

  deleteInspection(inspectionId : string){
    this.deleteInspectionSubscription  = this.httpService.deleteInspection(inspectionId).subscribe({
      next : (response) => {
        this.getAllInspections();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  clearBills() {
    this.searchForm.reset('', { emitEvent: false });
    this.getAllInspections();
    this.disableClear = false;
  }

  updateStatus() {

  }

  selectTicket(ticket: any) {
    this.addInspectionForm.patchValue(ticket);
    this.ticketPopupOpen();
  }

  openCenter(content: TemplateRef<any>) {
    this.modalService.open(content, { centered: true, backdrop: 'static' });
  }

  closeModal() {
    this.updateStatusForm.reset();
    this.modalService.dismissAll();
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortBy = sort.active;
    this.orderBy = sort.direction;
    this.handleSearch('', "keepPage");
  }

  pageChange(e: any) {    //  Page Change funcation   ---------
    if (this.page == e) return;
    this.page = e;
    this.handleSearch('', 'keepPage');
  }

  viewInspectionPDF(inspectionId : string){
    this.httpService.downloadInspection(inspectionId).pipe(takeUntilDestroyed(this.distroyRef)).subscribe((blob : Blob) => {
      const newBlob = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(newBlob);
      window.open(fileURL , "_blank");
    });
  }

  paginator(items: any, current_page: any, per_page_items: any, total_records: any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items,
      total_pages = Math.ceil(items.length / per_page);


    return {
      page: page,
      startPage: offset + 1,
      endPage: page * per_page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: total_records,
      total_pages: total_pages,
      data: paginatedItems
    };
  }

  ngOnDestroy() {
    this.createInspectionSubscription?.unsubscribe();
    this.getAllInspectionsSubscription?.unsubscribe();
    this.lastSearchTermSubscription?.unsubscribe();
    this.getInspectionDetailsById?.unsubscribe();
    this.deleteInspectionImageSubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
    this.getAllUsersSubscription?.unsubscribe();
    // Dispose of the offcanvas instance if it exists
    if (this.offcanvasInstance) {
      this.offcanvasInstance.dispose();
    }
  }

  get checkAddInspection() {
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_ADD);
  }

  get checkEditInspection() {
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_EDIT);
  }

  get checkCreateInspection() {
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_START);
  }

  get checkDeleteInspection(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_DELETE);
  }

  /**
   * An inspection is closed once it has been submitted (single-step workflow:
   * any user's submit moves it straight to Submitted). `Completed` is kept for
   * inspections closed under the old tenant/owner review chain.
   */
  isClosed(status: string | undefined): boolean {
    return status === 'Submitted' || status === 'Completed';
  }

  get displayInspectionEdit(){
      if(this.userInfo?.["role_identifier"] == APP_CONSTANTS.USER_ROLES.PARTER_ADMIN || this.userInfo?.["role_identifier"] == APP_CONSTANTS.USER_ROLES.SUPER_ADMIN){
        return true;
      }
      return false;
  }

  get inspectionReportView(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_REPORT_VIEW);
  }

  get inspectionDownloadView(){
    return this.authService.checkPermission(USER_PERMISSIONS.INSPECTIONS.INSPECTION_DOWNLOAD);
  }

  get checkManagedByFilter() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_MANAGED_BY_FILTER);
  }

  getAllUsers(){
    let query = `&role_identifier=${APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER}`;
    this.getAllUsersSubscription = this.httpService.getAllUsers(1, 200, query).subscribe({
      next : (response) => {
        for(let user of response.data.users){
            this.users.push(
              {
                value: user.uid,
                label: user.first_name + user.last_name,
                data: { name: user.first_name + user.last_name }
              }
            )
        }
      },
      error : (error) => {
        console.log(error);
      }
    })
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
